import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.scss';
import Ruoter from './ruoter';
import "./lang/i18n.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Ruoter />
  </React.StrictMode>
);


